import { render, staticRenderFns } from "./InspectionTaskDetail.vue?vue&type=template&id=1a201f12&scoped=true"
import script from "./InspectionTaskDetail.vue?vue&type=script&lang=js"
export * from "./InspectionTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./InspectionTaskDetail.vue?vue&type=style&index=0&id=1a201f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a201f12",
  null
  
)

export default component.exports